// import _ from 'lodash';

const productGridModal = {
  product: 0,
  selectedTab: '',
}
const ProductGridModalReducer = function (state = productGridModal, action) {
  switch (action.type) {
    case 'SET_PRODUCT_GRID_MODAL_ID': {
      return {
        ...state,
        product: action.value,
      }
    }
    case 'SET_PRODUCT_GRID_MODAL_SELECTED_TAB': {
      return {
        ...state,
        selectedTab: action.value,
      }
    }
    default: {
      return state
    }
  }
}

export default ProductGridModalReducer
